import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const OpenedBookIcon = createIcon({
  displayName: 'OpenedBookIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M17,5.317c0.925,-0.167 1.894,-0.264 2.956,-0.3c0.568,-0.019 1.044,0.431 1.044,0.999v11.837c0,0.542 -0.433,0.99 -0.974,0.998c-3.092,0.047 -5.42,0.617 -8.026,2.149c-2.606,-1.532 -4.934,-2.102 -8.026,-2.148c-0.541,-0.008 -0.974,-0.457 -0.974,-0.999v-11.837c0,-0.559 0.459,-1.018 1.017,-1c3.071,0.099 5.389,0.677 7.983,2.13"></path>
        <path d="M17,15.238v-12.226c0,-0.729 -0.766,-1.238 -1.417,-0.911c-1.756,0.88 -3.236,2.669 -3.583,4.511v14.388c0.396,-2.099 2.261,-4.129 4.331,-4.824c0.402,-0.135 0.669,-0.514 0.669,-0.938Z"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const OpenedBook: FC<IconProps> = (props) => {
  return <CustomIcon as={OpenedBookIcon} {...props} />
}

export default memo(OpenedBook)
